import { type Breakpoint, type Components, type Theme } from '@mui/material/styles';

import getStyleQuery from '../../../utils/tools/getStyleQuery';

export function grid(theme: Theme): Components<Theme> {
    const commonWidthClasses = {};
    const widthClasses = {};
    (['xs', 'sm', 'md', 'lg', 'xl'] as Breakpoint[]).map((b) => {
        for (let i = 1; i <= 12; i++) {
            commonWidthClasses[`& > div.MuiGrid-grid-${b}-${i}`] = {
                flexBasis: 'auto',
                flexGrow: 0,
                width: `calc(100% * ${i} / var(--Grid-parent-columns) - (var(--Grid-parent-columns) - ${i}) * (var(--Grid-parent-columnSpacing) / var(--Grid-parent-columns)))`,
                [theme?.breakpoints?.up(b)]: {
                    flexBasis: 'unset',
                    flexGrow: 'unset',
                    width: 'unset',
                },
            };
            widthClasses[`& > div.MuiGrid-grid-${b}-${i}`] = {
                [theme?.containerQueries?.up(b)]: {
                    flexBasis: 'auto',
                    flexGrow: 0,
                    width: `calc(100% * ${i} / var(--Grid-parent-columns) - (var(--Grid-parent-columns) - ${i}) * (var(--Grid-parent-columnSpacing) / var(--Grid-parent-columns)))`,
                },
            };
        }
    });

    return {
        MuiGrid: {
            styleOverrides: {
                root: {
                    [getStyleQuery()]: {
                        ...commonWidthClasses,
                    },
                },
                container: {
                    [getStyleQuery()]: {
                        containerType: 'inline-size',
                        ...widthClasses,
                    },
                },
            },
        },
    };
}
